// Single source of truth for Indian Financial Year (FY) logic — Apr 1 to
// Mar 31, dynamically computed off the real clock, never a hardcoded year.
// Every place in the app that needs "is this batch/date in the current FY"
// goes through here instead of reimplementing the boundary math locally.

export interface FinancialYearRange {
  /** Calendar year the FY starts in — e.g. 2026 for FY 2026-27. */
  startYear: number;
  start: number;
  end: number;
}

/** offset 0 = current FY, -1 = previous FY, +1 = next FY. */
export function getFinancialYearRange(offset = 0, reference: Date = new Date()): FinancialYearRange {
  const fyStartYear = (reference.getMonth() >= 3 ? reference.getFullYear() : reference.getFullYear() - 1) + offset;
  return {
    startYear: fyStartYear,
    start: new Date(fyStartYear, 3, 1, 0, 0, 0, 0).getTime(),
    end: new Date(fyStartYear + 1, 2, 31, 23, 59, 59, 999).getTime(),
  };
}

export function getCurrentFinancialYear(): FinancialYearRange {
  return getFinancialYearRange(0);
}

/** "FY 2026-27" — short two-digit end year, matching common Indian convention. */
export function formatFinancialYearLabel(range: FinancialYearRange): string {
  return `FY ${range.startYear}-${String(range.startYear + 1).slice(2)}`;
}

/** True if the given epoch ms timestamp falls inside the current FY. */
export function isInCurrentFinancialYear(timestamp: number): boolean {
  const { start, end } = getCurrentFinancialYear();
  return timestamp >= start && timestamp <= end;
}
